import { MultiFormTab, MultiFormTabs } from '@if/mui'
import useFeatureFlags from '@src/data/api/featureSwitch-api/featureSwitch-api'
import { Merchant } from '@src/data/types/Merchant'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useBannerGeneralTab } from './tabs/BannerGeneralTab'
import { useBannerPromotionTab } from './tabs/BannerPromotionTab'

interface Props {
  banner: Merchant
}

const BannerTabsForm = ({ banner }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [featureFlags] = useFeatureFlags()

  const general = useBannerGeneralTab(banner)
  const promotion = useBannerPromotionTab(banner)

  return (
    <MultiFormTabs
      onCancel={() => navigate(`/banner/${banner.id}/view?financingCompanyId=${banner.financingCompanyId}`)}
    >
      <MultiFormTab
        label={t('banner.generalSettings')}
        useFormSetup={general.useFormSetup}
        onSubmit={general.onSubmit}
        onError={general.onError}
      >
        {general.children}
      </MultiFormTab>
      {featureFlags?.useCustomFlashPlan && (
        <MultiFormTab
          label={t('banner.promotionSettings')}
          useFormSetup={promotion.useFormSetup}
          onSubmit={promotion.onSubmit}
          onError={promotion.onError}
        >
          {promotion.children}
        </MultiFormTab>
      )}
    </MultiFormTabs>
  )
}

export default memo(BannerTabsForm)
